export { PartnershipsFeature } from './lib/partnerships/partnerships'
export type { PartnershipsStoryContent } from './lib/partnerships/types/partnerships-page'
export { getStaticProps } from './lib/partnerships/get-static-props'
